<template>
    <v-card class="dialog" color="grey lighten-3" height="1080px">
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="$emit('fechar')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Meus Atendimentos</v-toolbar-title>
        </v-toolbar>
        <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
            <v-col cols="12">
                <v-layout justify-center>
                    <v-card flat class="mt-1" max-width="700px" color="grey lighten-3" elevation="3">
                    <v-progress-linear color="orange" v-if="load" :indeterminate="true" />
                    <v-date-picker
                        :disabled="load"
                        v-model="date"
                        full-width
                        header-color="green"
                        locale="pt-Br"
                    >
                    </v-date-picker>
                </v-card>
                </v-layout>
            </v-col>
        </v-row>
        <v-row v-if="!isExibirAtendimento" :class="isExibirAtendimento?'animated fadeOut': 'animated fadeIn'">
            <v-layout justify-center>             
                <v-card width="700px">
                  <v-card-title dense class="mb-0 mt-0">
                    <v-spacer/>
                    <v-text-field v-model="search" label="Buscar Paciente" append-icon="search"></v-text-field>
                  </v-card-title>
                  <v-divider/>
                    <v-progress-linear color="orange" v-show="load" :indeterminate="true" />
                    <v-card v-if="load" color="grey lighten-4" width="700px">
                      <v-list v-for="i in 4" :key="i">
                        <v-skeleton-loader type="list-item"/>
                        <v-divider/>
                      </v-list>
                    </v-card>
                    <v-list-item v-if="!load && consultas.length == 0">
                      <v-list-item-title>
                            Não foram encontrados atendimentos para esta data
                      </v-list-item-title>
                    </v-list-item>
                    <v-virtual-scroll
                        v-if="!load"
                        :class="load?'animated fadeIn':''"
                        :bench="0"
                        :items="consultasFiltradas"
                        height="250"
                        item-height="60"
                    >
                        <template v-slot:default="{ item }">
                            <v-list-item :key="item.os" :disabled="load" @click="isExibirAtendimento = true, currentSelected = item">
                              <v-list-item-content>
                                <v-list-item-title>
                                    <strong>{{ item.nomePaciente }}</strong>
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <b>OS: </b>{{item.os}} <b>ID Paciente:</b> {{ item.idPaciente }} <b>Data de nascimento:</b> {{ formatarData(item.dataNascimento) }}
                                </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-spacer/>
                                  <v-btn icon>
                                    <v-icon small color="primary">
                                      mdi-open-in-new
                                    </v-icon>
                                  </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                </v-virtual-scroll>
                </v-card>
            </v-layout>
        </v-row>

        <v-row>
          <v-layout justify-center>
            <v-card width="750px" height="600px" rounded v-if="isExibirAtendimento" :class="isExibirAtendimento?'animated fadeIn': 'animated fadeOut'" class="mt-4">
              <!-- <historico :ficha="currentSelected"/> -->
               <v-card-title>
                {{ currentSelected.nomePaciente }}
               </v-card-title>

               <v-card class="ma-2" outlined flat height="450px">
                <v-row justify="center">
                <v-col cols="6">                  
                  <v-card-title>
                    Exames
                  </v-card-title>
                  <v-divider/>
                  <v-virtual-scroll
                    height="350"
                    :items="exames"
                    item-height="20"
                  >
                  <template v-slot:default="{ item }">
                    <ul class="w3-ul w3-border grey lighten-2">
                        <li>{{item.apelido}}</li>
                    </ul>
                </template>
                </v-virtual-scroll>
                </v-col>
                <v-divider vertical/>
                <v-col cols="6">
                  <v-card-title>
                    Exames Laboratório
                  </v-card-title>
                  <v-divider/>
                  <v-virtual-scroll
                    height="350"
                    :items="examesSadt"
                    item-height="20"
                  >
                  <template v-slot:default="{ item }">
                    <ul class="w3-ul w3-border grey lighten-2">
                        <li>{{item.apelido}}</li>
                    </ul>
                </template>
                </v-virtual-scroll>
                </v-col>
                
              </v-row>
               </v-card>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" class="white--text" @click="isExibirAtendimento = false">
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                </v-btn>
                <v-btn color="red" class="white--text" @click="isExibirAtendimento = false">
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-layout>
        </v-row>
    </v-card>
</template>
<script>
import medicoService from '../../services/medico.service'
import posAtendimentoService from '../../services/posAtendimento.service'
import moment from 'moment'
// import historico from '../medico/historico.vue'

export default {
  components: {
    //historico
  },
  data: () => ({
    user: '',
    load: false,
    dialog: false,
    date: null,
    consultas: [],
    isExibirAtendimento: false,
    currentSelected: '',
    search: '',
    exames: [],
    examesSadt: []
  }),
  mounted () {
    this.user = this.$store.getters.usuario
    this.carregarDataAtual()
    this.buscarPacientesConsultasPorData()
  },
  methods: {
    formatarData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    carregarDataAtual () {
      var now = new Date()
      var year = now.getFullYear()
      var month = String(now.getMonth() + 1).padStart(2, '0')
      var day = String(now.getDate()).padStart(2, '0')
      this.date = `${year}-${month}-${day}`
      console.log('antes de chamar')
    },
    buscarPacientesConsultasPorData () {
      this.load = true
      posAtendimentoService.buscarPacientesConsultasPorData(this.user.id, this.date).then(r => {
        if (r.status == 200) {
          console.log('VEIO ', r.data)
          this.consultas = r.data
        } else {
          console.log('NAO VEIO')
        }
      }).finally(() => {
        this.load = false
      })
    },
    listarSolicitacaoExamesPorIdPos () {
      console.log('chamouuu', this.currentSelected.idPosConsulta)
      // this.load = true
      posAtendimentoService.listarSolicitacaoExamesPorIdPos(this.currentSelected.idPosConsulta).then(r => {
        if (r.status == 200) {
          var aux1 = []
          var aux2 = [] 
          console.log('VEIO ', r.data)
          r.data.forEach(element => {
            if (element.sadt == 0) {
              aux1.push(element)
            } else {
              aux2.push(element)
            }
          })

          this.exames = aux1
          this.examesSadt = aux2

        } else {
          console.log('NAO VEIO')
        }
      }).finally(() => {
        this.load = false
      })
    }
  },
  computed: {
    consultasFiltradas () {
      if (!this.search) {
        // console.log('aaaa')
        return this.consultas
      }
      const busca = this.search.toLowerCase()
      return this.consultas.filter(item => {
        const nome = item.nomePaciente.toLowerCase()
        return nome.includes(busca)
      })
    }
  },
  watch: {
    date (val) {
      if (val != null) {
        this.buscarPacientesConsultasPorData()
      } else {
      }
    },
    isExibirAtendimento (val) {
      if (val == true) {
        this.listarSolicitacaoExamesPorIdPos()
      }      
    }
  }
}
</script>
<style scoped>
</style>